import { render } from "./HeaderSideMenuV1.vue?vue&type=template&id=344f3f0b&ts=true"
import script from "./HeaderSideMenuV1.vue?vue&type=script&lang=ts"
export * from "./HeaderSideMenuV1.vue?vue&type=script&lang=ts"

import "./HeaderSideMenuV1.vue?vue&type=style&index=0&id=344f3f0b&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__